import styled from "styled-components";
import { imageRatioToWidth } from "./helpers";
import { Grid } from "react-styled-flexboxgrid";
import { breakpoints } from '../shared';

export const AdContainer = styled(Grid)`
    display: flex;
    justify-content: center;
    padding: 0.75rem 0;
`;

export const LingoAdContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const LingoAdLink = styled.a`
    display: flex;
`;

export const RowGridContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    /* This is a work around for a scrollbar appearing and changing
        the container width (without a resize event) once items are 
        added to the list. This forces the element to show a scroll bar
        and therefore take its width into account when measuring the size
        of the component.        
     */
    min-height: 367px;
`;

export const PhotoGridItemStyle = styled.div`
    img {
        // Technically this block is the "correct" styles
        // However the images don't end up being sized 100%
        // correctly (off by a few px), so object-fit is used to
        // resize the image to fill the container
        /* display: block;
    width: 100%;
    height: auto;
   */

        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    min-height: 150px;
    height: 100%;
    padding: 0.75rem;
    
    /* mobile */
    @media (max-width: ${breakpoints.mobileMax}rem) {
        padding: 0.5rem;
    }
    ${({ ratio }) => imageRatioToWidth({ ratio })}
`;
